<template>
  <div>
    <div v-if="gameId == 0">
      <v-row align="center">
        <v-col
          class="d-flex"
          cols="12"
          sm="6"
        >
          <v-select
            v-model="query.slug"
            :items="slugList"
            item-text="name"
            item-value="slug"
            label="เลือกประเภทเกมส์"
            outlined
            @change="getGameLists"
          />
        </v-col>
        <v-col
          class="d-flex"
          cols="12"
          sm="6"
        >
          <v-select
            v-model="query.gameId"
            :items="gameList"
            item-text="name"
            item-value="id"
            label="เลือกรอบเกมส์"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          lg="6"
        >
          <div class="d-flex align-items-baseline my-2">
            <v-text-field
              v-model="query.text"
              prepend-icon="mdi-magnify"
              autocomplete="off"
              hide-details
              label="ค้นหา"
              clearable
              class="mx-3"
              @input="query.text = $event"
            />
            <v-btn
              color="primary"
              @click="fetchData"
            >
              <v-icon left>
                mdi-check
              </v-icon>
              ค้นหา
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table
      :footer-props="footer"
      :headers="headers"
      :items.sync="items"
      :loading="loading"
      :multi-sort="false"
      :options.sync="options"
      :server-items-length="totalItems"
      class="elevation-0"
      item-key="id"
    >
      <!-- item -->
      <template #item.detail="{ item }">
        <div class="text-center">
          <v-btn
            icon
            color="green darken-3"
            title="ดูรายละเอียด"
            @click="displayDialog(item)"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>
      </template>
      <template #item.name="{ item }">
        <span class="text-info">{{ item.user.name }}</span>
      </template>
      <template #item.game_name="{ item }">
        <span class="text-danger">{{ item.game.master.name }} {{ item.game.readable_edition }} {{ item.game.game_thai_date }}</span>
      </template>
      <template #item.created_at="{ item }">
        <span
          v-if="item.created_at"
          class="d-block"
        >{{
          $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
        }}</span>
      </template>

      <template #item.amount="{ item }">
        <span>{{
          Number(item.amount).toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })
        }}</span>
      </template>

      <template #item.win_amount="{ item }">
        <span>{{
          item.win_amount
            ? Number(item.win_amount).toLocaleString("en-US", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })
            : 0
        }}</span>
      </template>

      <template #item.status="{ item }">
        <v-chip
          v-if="item.status === 'pending'"
          class="ma-2 text-lg"
          label
          small
          color="light-blue"
          text-color="white"
        >
          กำลังประมวลผล
        </v-chip>
        <v-chip
          v-else-if="item.status === 'created'"
          class="ma-2 text-lg"
          label
          small
          color="light-blue"
          text-color="white"
        >
          รอยืนยันผล
        </v-chip>
        <v-chip
          v-else-if="item.status === 'cancel_by_game'"
          class="ma-2 text-lg"
          label
          small
          color="primary"
        >
          ยกเลิกเกมส์
        </v-chip>
        <v-chip
          v-else-if="item.status === 'cancel_by_user'"
          class="ma-2 text-lg"
          label
          small
          color="primary"
        >
          ยกเลิกโพย
        </v-chip>
        <v-chip
          v-else-if="item.status === 'committed'"
          class="ma-2 text-lg"
          label
          small
          color="light-blue"
          text-color="white"
        >
          กำลังคำนวน
        </v-chip>
        <v-chip
          v-else-if="item.status === 'complete'"
          class="ma-2 text-lg"
          label
          small
          color="success"
        >
          จบเกมส์
        </v-chip>
      </template>

      <template #item.id="{ item }">
        <span>{{ `#${item.lotto_game_id}${item.id}` }}</span>
      </template>
    </v-data-table>

    <v-dialog
      v-if="selectedItem"
      v-model="selectedItem"
      width="1120"
      max-width="100vw"
      scrollable
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-card-title>
            <span class="text-body-1 text-uppercase text-monospace">{{
              gameName
            }}</span>
          </v-card-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click="closeDialog()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="pt-10">
          <ticket-number :transaction="ticketNumberItem" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="preload"
      v-model="preload"
      persistent
      width="500"
      max-width="100vw"
    >
      <v-card class="pa-md-10 mx-lg-auto">
        <v-container class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="primary"
          />
        </v-container>
      </v-card>
    </v-dialog>
    <b-modal
      id="bv-modal-result"
      size="xl"
      hide-footer
    />
  </div>
</template>
<script>
import axios from 'axios';
import ticketNumber from './ticket-number-table.vue';

export default {
  name: 'TicketAdminTable',
  components: { ticketNumber },
  props: {
    slugList: { default: '', Type: Array },
    gameId: { default: '', Type: Number },
  },
  data() {
    return {
      footer: {
        itemsPerPageOptions: [10, 25, 50, 100],
      },
      loading: true,
      search: false,
      sortable: false,
      headers: [
        {
          text: 'ดูโพย',
          value: 'detail',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'ชื่อผู้เล่น',
          value: 'name',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'เกมส์',
          value: 'game_name',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'เวลาแทง',
          value: 'created_at',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'ยอดแทง',
          value: 'amount',
          align: 'center',
          cellClass: 'text-monospace',
          sortable: false,
        },
        {
          text: 'ยอดถูก',
          value: 'win_amount',
          align: 'center',
          justify: 'center',
          cellClass: 'text-monospace',
          sortable: false,
        },
        {
          text: 'สถานะ', value: 'status', align: 'center', sortable: false,
        },
        {
          text: 'โพย',
          value: 'id',
          align: 'center',
          sortable: false,
        },
      ],
      items: [],
      totalItems: 0,
      options: {},
      query: {
        slug: null,
        gameId: null,
        text: '',
      },
      showDateDialog: false,
      selectedItem: false,
      gameName: '',
      ticketNumberItem: [],
      preload: false,
      gameList: [],
    };
  },
  computed: {},
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },

  mounted() {},

  methods: {
    fetchData() {
      this.loading = true;
      if (this.gameId > 0) {
        var lottoId = this.gameId;
      } else {
        var lottoId = this.query.gameId;
      }
      axios
        .get('/api/getTickets', {
          params: {
            page: this.options.page,
            sortBy: this.options.sortBy[0],
            sortDirection:
              this.options.sortDesc.length > 0
                ? this.options.sortDesc[0]
                  ? 'ASC'
                  : 'DESC'
                : null,
            lottoId: this.gameId > 0 ? this.gameId : this.query.gameId,
            text:
              this.query.text.trim().length === 0
                ? null
                : this.query.text.trim(),
            pageSize: this.options.itemsPerPage,
          },
        })
        .then((response) => {
          this.items = response.data.data;
          this.totalItems = response.data.total;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.loading = false;
        });
    },

    getGameLists() {
      const link = `/api/getGameLists/${this.query.slug}`;

      this.preload = true;
      axios
        .get(link)
        .then((response) => {
          Vue.set(this, 'gameList', response.data);
        })
        .finally(() => {
          this.preload = false;
        });
    },

    displayDialog(item) {
      this.gameName = `#${item.lotto_game_id}${item.id} ${item.game.master.name} ${item.game.readable_edition}`;
      this.preload = true;
      axios
        .get(`/api/user/ticketNumber/${item.id}`)
        .then((response) => {
          Vue.set(this, 'ticketNumberItem', response.data);
        })
        .finally(() => {
          this.preload = false;
          this.selectedItem = true;
        });
    },

    closeDialog() {
      this.selectedItem = false;
    },
  },
};
</script>
